export default __webpack_public_path__ + "media/images/icons/chevron-right-solid-c3ee4024f656e1d3c1043faac9201e5f.svg";